<template>
  <div class="content">
    <ToolTitle :title="form.name" :menu="true" :menuby="'form'" />
    <ToolLoading v-if="!isloaded" />
    <div v-if="isloaded" class="content__form">
      <FormInput :placeholder="'Formun gönderileceği kişiler:'" v-model="form.smtp.to" />
      <FormInput :placeholder="'Formun gönderileceği kişiler CC:'" v-model="form.smtp.cc" />
      <FormInput :placeholder="'Formun gönderileceği kişiler BCC:'" v-model="form.smtp.bcc" />
      <FormInput :placeholder="'Sunucu:'" v-model.trim="form.smtp.host" />
      <FormInput :placeholder="'User:'" v-model.trim="form.smtp.user" />
      <FormInput :placeholder="'Port:'" v-model.trim="form.smtp.port" />
      <FormCheckbox :placeholder="'SSL'" v-model="form.smtp.secure" />
      <FormCheckbox :placeholder="'Authentication'" v-model="form.smtp.authentication" />
      <FormInput
        v-if="form.smtp.authentication"
        :placeholder="'Authentication username:'"
        v-model.trim="form.smtp.auth.username"
      />
      <FormInputPassword
        v-if="form.smtp.authentication"
        :placeholder="'Authentication password:'"
        v-model.trim="form.smtp.auth.password"
      />
      <FormInput :placeholder="'E-posta subject:'" v-model.trim="form.smtp.subject" />
      <FormButton @action="update()" :text="'Kaydet'" :status="status" />
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import * as Helpers from "@/helpers/";

export default {
  data() {
    return {
      form: {},
      isloaded: false,
      status: {
        loading: false,
        message: "",
        type: ""
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    init: async function() {
      let vm = this;

      await API.getForm(vm.$route.params.company, vm.$route.params.form).then(
        response => {
          vm.form = response.result;
        }
      );

      vm.isloaded = true;
    },
    update: async function() {
      let vm = this;

      vm.status.loading = true;
      vm.status.type = "";
      vm.status.message = "Form düzenleniyor...";

      vm.form.updated = {
        by: vm.$store.getters.getUser,
        date: await Helpers.currentDateTime()
      };

      await API.updateForm(vm.form)
        .then(async response => {
          vm.status.type = "success";
          if (response.status.code != 200) vm.status.type = "Error";
          vm.status.message = response.status.message;

          vm.form = response.result;
        })
        .catch(error => {
          vm.status.type = "Error";
          vm.status.message = error;
        });

      vm.status.loading = false;
    }
  }
};
</script>